import gsap from 'gsap'
class Transitions {
  action (timeline, direction) {
    if (direction === 'play') {
      timeline.play()
    } else if (direction === 'reverse') {
      timeline.reverse(0)
    } else {
      timeline.pause()
    }
  }

  titleTransition (title, devider) {
    const tl = gsap.timeline({})
    tl.from(title, {
      y: -100,
      opacity: 0,
      ease: 'back',
      delay: 0.5
    })
    tl.from(devider, {
      x: 100,
      opacity: 0
    }, 1)
  }

  fadeInUp (el, done) {
    const tl = gsap.timeline({
    })
    tl.fromTo(el,
      {
        opacity: 0,
        y: -400
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.5,
        onComplete: done
      }
    )
  }
  fadeInDown (el, done) {
    const tl = gsap.timeline({
    })
    tl.fromTo(el,
      {
        opacity: 0,
        y: 400
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.5,
        onComplete: done
      }
    )
  }
  fadeOutDown (el, done) {
    const tl = gsap.timeline({
    })
    tl.fromTo(el,
      {
        opacity: 1,
        y: 0
      },
      {
        opacity: 0,
        y: 400,
        duration: 0.5,
        onComplete: done
      }
    )
  }
  fadeOutUp (el, done) {
    const tl = gsap.timeline({
    })
    tl.fromTo(el,
      {
        opacity: 1,
        y: 0
      },
      {
        opacity: 0,
        y: -400,
        duration: 0.5,
        onComplete: done
      }
    )
  }
  fadeInLeft (el, done) {
    const tl = gsap.timeline({
    })
    tl.fromTo(el,
      {
        opacity: 0,
        x: -400
      },
      {
        opacity: 1,
        x: 0,
        duration: 0.3,
        delay: 0.3,
        onComplete: done
      }
    )
  }
  fadeInRight (el, done) {
    const tl = gsap.timeline({
    })
    tl.fromTo(el,
      {
        opacity: 0,
        x: 400
      },
      {
        opacity: 1,
        x: 0,
        duration: 0.3,
        delay: 0.3,
        onComplete: done
      }
    )
  }
  fadeOutRight (el, done) {
    const tl = gsap.timeline({
    })
    tl.fromTo(el,
      {
        opacity: 1,
        x: 0
      },
      {
        opacity: 0,
        x: 400,
        duration: 0.3,
        onComplete: done
      }
    )
  }
  fadeOutLeft (el, done) {
    const tl = gsap.timeline({
    })
    tl.fromTo(el,
      {
        opacity: 1,
        x: 0
      },
      {
        opacity: 0,
        x: -400,
        duration: 0.3,
        onComplete: done
      }
    )
  }

  leafTopLeft (el, done, insetChange) {
    const tl = gsap.timeline({
    })
    tl.fromTo(el,
      {
        opacity: 0,
        top: (-35 + insetChange) + '%',
        left: (-30 + insetChange) + '%'
      },
      {
        opacity: 0.4,
        top: (-30 + insetChange) + '%',
        left: (-25 + insetChange) + '%',
        duration: 1,
        delay: 0.75,
        onComplete: done
      }
    )
  }
  leafTopRight (el, done, insetChange) {
    const tl = gsap.timeline({
    })
    tl.fromTo(el,
      {
        opacity: 0,
        top: (-35 + insetChange) + '%',
        right: (-30 + insetChange) + '%'
      },
      {
        opacity: 0.4,
        top: (-30 + insetChange) + '%',
        right: (-25 + insetChange) + '%',
        duration: 1,
        delay: 0.75,
        onComplete: done
      }
    )
  }
  leafBottomLeft (el, done, insetChange) {
    const tl = gsap.timeline({
    })
    tl.fromTo(el,
      {
        opacity: 0,
        bottom: (-35 + insetChange) + '%',
        left: (-30 + insetChange) + '%'
      },
      {
        opacity: 0.4,
        bottom: (-30 + insetChange) + '%',
        left: (-25 + insetChange) + '%',
        duration: 1,
        delay: 0.75,
        onComplete: done
      }
    )
  }
  leafBottomRight (el, done, insetChange) {
    const tl = gsap.timeline({
    })
    tl.fromTo(el,
      {
        opacity: 0,
        bottom: (-35 + insetChange) + '%',
        right: (-30 + insetChange) + '%'
      },
      {
        opacity: 0.4,
        bottom: (-30 + insetChange) + '%',
        right: (-25 + insetChange) + '%',
        duration: 1,
        delay: 0.75,
        onComplete: done
      }
    )
  }
}

var transitions = new Transitions()

export default transitions
